import { useLazyQuery } from '@apollo/client';

import { getFunds } from '../queries';

import { GetFundsQuery, GetFundsQueryVariables } from '@typings/operations';

export const useGetFunds = () =>
  useLazyQuery<GetFundsQuery, GetFundsQueryVariables>(getFunds);
